@use 'src/globals/main';

pn-progress-stepper .pn-progress-stepper {
  position: relative;

  width: 100%;
  background: main.$gray50;
  height: 0.5em;
  border-radius: 0.5em;
  box-shadow: (0 0 0 0.0625em main.$gray400);

  &[data-full] .pn-progress-stepper-value {
    border-top-right-radius: 0.5em;
    border-bottom-right-radius: 0.5em;
  }

  &-label {
    margin-bottom: 0.5em;
  }

  &-value {
    position: absolute;
    top: -0.0625em;
    left: -0.0625em;

    height: 0.625em;
    background-color: main.$blue700;
    width: calc(var(--progress-value) + 0.125em);
    border-radius: 0.5em 0 0 0.5em;

    @include main.pn-transition('width, border-radius', main.$timing-layout);
  }
}
